export enum RectangleAnchorPointName {
    LEFT_TOP = 'leftTop',
    LEFT_BOTTOM = 'leftBottom',
    RIGHT_BOTTOM = 'rightBottom',
    RIGHT_TOP = 'rightTop',
}
export type CornerPoint = {
    left: number;
    top: number;
    type: RectangleAnchorPointName;
};

export enum EDeformationEvent {
    CONFIRM = 'confirm',
    CANCEL = 'cancel',
    INNER_CONFIRM = 'innerConfirm',
}
